import React from "react";
import { arrayOf, oneOf, number, object, string } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { FluidSections } from "../FluidSections";
// eslint-disable-next-line import/no-cycle
import { ComponentsSlider } from "./ComponentsSlider";

const ComponentsSliderFluid = ({
	slides,
	slidesPerPage,
	variant,
	locale,
	paging,
	navigation,
	id,
}) => (
	<ComponentsSlider
		slides={slides.map(slide => ({
			id: slide.id,
			view: <FluidSections useWrapper={false} data={slide} locale={locale} />,
		}))}
		slidesPerPage={slidesPerPage}
		variant={variant}
		paging={paging}
		navigation={navigation}
		id={id}
	/>
);

ComponentsSliderFluid.propTypes = {
	slides: arrayOf(object).isRequired,
	locale: string,
	slidesPerPage: number,
	variant: string,
	id: string,
	paging: oneOf([true, false, "desktopOnly"]),
	navigation: oneOf([true, false, "desktopOnly"]),
};

ComponentsSliderFluid.defaultProps = {
	locale: null,
	slidesPerPage: null,
	variant: null,
	paging: null,
	navigation: null,
	id: null,
};

export default ComponentsSliderFluid;
export { ComponentsSliderFluid };
